export default (selector, options = {}) => {

    if (!selector) {
        throw new Error('Selector is empty');
    }

    if (!(selector instanceof jQuery)) {
        selector = $(selector);
    }

    if (!selector.length) {
        return;
    }

    const defaultOptions = {};

    options = Object.assign(defaultOptions, options);

    require.ensure([], require => {
        require('@fancyapps/fancybox');
        require('@fancyapps/fancybox/dist/jquery.fancybox.css');
        $(selector).fancybox(options);
    });
};


// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/modules/fancybox.js